import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

const appendPrefixUrl = (prefixUrl = {}, url) =>
  [
    `/vendor/${prefixUrl.vendorId}`,
    `/contract/${prefixUrl.contractId}`,
    `/version/${prefixUrl.versionId}`,
    `${url}`,
  ].join('')

export const renew = async (prefixUrl) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, '/renewal'),
  })

  return response?.data
}
